<div class="page-header">
    <h2 id="workersCompensationHeader">
        Workers Compensation Information</h2>
</div>
<div [formGroup]="workersCompensationForm">
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="employeeFirstName">Employee's first name</label>
            <input type="text" class="form-control" id="employeeFirstName" name="employeeFirstName" [formControl]="employeeFirstName" aria-required="true" aria-describedby="employeeFirstName"
                [ngClass]="{'has-error':(employeeFirstName.invalid && employeeFirstName.touched)}">
            <div *ngIf="employeeFirstName.invalid && employeeFirstName.touched" class="alert alert-danger nw-field-error" id="employeeFirstNameErrorId">
                <span *ngIf="employeeFirstName.hasError('required')" id="employeeFirstNameErrorMessage">Required</span>
                <span *ngIf="employeeFirstName.hasError('pattern')" id="employeeFirstNameErrorMessage">Employee's first name
                    is invalid</span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="employeeLastName">Employee's last name</label>
            <input type="text" class="form-control" id="employeeLastName" name="employeeLastName" [formControl]="employeeLastName" aria-required="true" aria-describedby="employeeLastName"
                [ngClass]="{'has-error':(employeeLastName.invalid && employeeLastName.touched)}">
            <div *ngIf="employeeLastName.invalid && employeeLastName.touched" class="alert alert-danger nw-field-error" id="employeeLastNameErrorId">
                <span *ngIf="employeeLastName.hasError('required')" id="employeeLastNameErrorMessage">Required</span>
                <span *ngIf="employeeLastName.hasError('pattern')" id="employeeLastNameErrorMessage">Employee's last name
                    is invalid</span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="employeePhoneNumber">
                Employee's phone number</label>
            <input type="text" class="form-control" id="employeePhoneNumber" name="employeePhoneNumber" aria-required="true" aria-describedby="employeePhoneNumber" placeholder="555-555-5555"
                [formControl]="employeePhoneNumber" [ngClass]="{'has-error':(employeePhoneNumber.invalid && employeePhoneNumber.touched)}">
            <div *ngIf="employeePhoneNumber.invalid && employeePhoneNumber.touched" class="alert alert-danger nw-field-error" id="employeePhoneNumberErrorId">
                <span *ngIf="employeePhoneNumber.hasError('required')" id="employeeLastNameErrorMessage">Required</span>
                <span *ngIf="employeePhoneNumber.hasError('pattern')" id="employeeLastNameErrorMessage">Employee's phone
                    number is invalid</span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="employeeEmail" class="optional">Employee's email</label>
            <input type="text" class="form-control" id="employeeEmail" name="employeeEmail" [formControl]="employeeEmail" aria-required="false" aria-describedby="employeeEmail"
                [formControl]="employeePhoneNumber" [ngClass]="{'has-error':(employeeEmail.invalid && employeeEmail.touched)}" placeholder="name@domain.com">
            <div *ngIf="employeeEmail.invalid && employeeEmail.touched" class="alert alert-danger nw-field-error" id="employeeEmailErrorId">
                <span *ngIf="employeeEmail.hasError('pattern')" id="employeeEmailErrorMessage">Employee's email is invalid</span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="employeeOccupation">Employee's occupation</label>
            <input type="text" class="form-control" id="employeeOccupation" name="employeeOccupation" [formControl]="employeeOccupation" aria-required="true" aria-describedby="employeeOccupation"
                [ngClass]="{'has-error':(employeeOccupation.invalid && employeeOccupation.touched)}">
            <div *ngIf="employeeOccupation.invalid && employeeOccupation.touched" class="alert alert-danger nw-field-error" id="employeeOccupationErrorId">
                <span *ngIf="employeeOccupation.hasError('required')" id="employeeOccupationErrorMessage">Required</span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="hiredDate">Employee's date of hire</label>
            <input type="text" class="form-control" id="hiredDate" name="hiredDate" [formControl]="hiredDate" aria-required="true" aria-describedby="hiredDate" placeholder="mm/dd/yyyy"
                [ngClass]="{'has-error':(hiredDate.invalid && hiredDate.touched)}">
            <div *ngIf="hiredDate.invalid && hiredDate.touched" class="alert alert-danger nw-field-error" id="hiredDateErrorId">
                <span *ngIf="hiredDate.hasError('required')" id="hiredDateErrorMessage">Required</span>
                <span *ngIf="hiredDate.hasError('pattern')" id="hiredDateErrorMessage">Hired Date is invalid</span>
            </div>
            <input type="checkbox" #hiredDateNotKnown id="hiredDateNotKnown" style="margin-right:10px;margin-bottom:20px" (change)="dateFilterChanged(hiredDateNotKnown.checked,hiredDate)">I
            don't know
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="causeOfInjury">Cause of employee's injury</label>
            <select class="form-control nw-input--medium" name="causeOfInjury" id="causeOfInjury" aria-required="true" aria-describedby="causeOfInjury" [formControl]="causeOfInjury"
                [ngClass]="{'has-error':(causeOfInjury.touched && causeOfInjury.invalid)}">
                <option value="" selected>Select</option>
                <option *ngFor="let cause of causesOfInjuries">{{cause}}</option>
            </select>
            <div *ngIf="causeOfInjury.touched && causeOfInjury.invalid" class="alert alert-danger nw-field-error" id="causeOfInjuryErrorId">
                <span id="causeOfInjuryErrorMessage">Required</span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="typeOfInjury">Primary type of injury</label>
            <select class="form-control nw-input--medium" name="typeOfInjury" id="typeOfInjury" aria-required="true" aria-describedby="typeOfInjury" [formControl]="typeOfInjury"
                [ngClass]="{'has-error':(typeOfInjury.touched && typeOfInjury.invalid)}">
                <option value="" selected>Select</option>
                <option *ngFor="let injury of primaryTypesOfInjuries">{{injury}}</option>
            </select>
            <div *ngIf="typeOfInjury.touched && typeOfInjury.invalid" class="alert alert-danger nw-field-error" id="typeOfInjuryErrorId">
                <span id="typeOfInjuryErrorMessage">Required</span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="severityOfInjury">Severity of injury</label>
            <select class="form-control nw-input--medium" name="severityOfInjury" id="severityOfInjury" aria-required="true" aria-describedby="severityOfInjury" [formControl]="severityOfInjury"
                [ngClass]="{'has-error':(severityOfInjury.touched && severityOfInjury.invalid)}">
                <option value="" selected>Select</option>
                <option *ngFor="let severity of injurySeverities">{{severity}}</option>
            </select>
            <div *ngIf="severityOfInjury.touched && severityOfInjury.invalid" class="alert alert-danger nw-field-error" id="severityOfInjuryErrorId">
                <span id="severityOfInjuryErrorMessage">Required</span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="areaOfInjury">Area of injury</label>
            <select class="form-control nw-input--medium" name="areaOfInjury" id="areaOfInjury" aria-required="true" aria-describedby="areaOfInjury" [formControl]="areaOfInjury"
                [ngClass]="{'has-error':(areaOfInjury.touched && areaOfInjury.invalid)}">
                <option value="" selected>Select</option>
                <option *ngFor="let area of injuryAreas" [value]="area">{{area}}</option>
            </select>
            <div *ngIf="areaOfInjury.touched && areaOfInjury.invalid" class="alert alert-danger nw-field-error" id="areaOfInjuryErrorId">
                <span id="areaOfInjuryErrorMessage">Required</span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="injuryDetail">Injury detail</label>
            <select class="form-control nw-input--medium" name="injuryDetail" id="injuryDetail" aria-required="true" aria-describedby="injuryDetail" [formControl]="injuryDetail"
                [ngClass]="{'has-error':(injuryDetail.touched && injuryDetail.invalid)}">
                <option value="" selected>Select</option>
                <option *ngFor="let injury of injuryDetails">{{injury}}</option>
            </select>
            <div *ngIf="injuryDetail.touched && injuryDetail.invalid" class="alert alert-danger nw-field-error" id="injuryDetailErrorId">
                <span id="injuryDetailErrorMessage">Required</span>
            </div>
        </div>
    </div>
    <div class="row form-group" *ngIf="!areaOfInjury.value">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="additionalInjuryDetail">Additional injury detail</label>
            <select class="form-control nw-input--medium" name="additionalInjuryDetail" id="additionalInjuryDetail" aria-required="true" aria-describedby="additionalInjuryDetail"
                [formControl]="additionalInjuryDetail">
                <option value="" selected>Select</option>
            </select>
        </div>
    </div>
    <div class="row form-group" *ngIf="areaOfInjury.value">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="detailedBodyPart">Detailed body part injured</label>
            <select class="form-control nw-input--medium" name="detailedBodyPart" id="detailedBodyPart" aria-required="true" aria-describedby="detailedBodyPart" [formControl]="detailedBodyPart"
                [ngClass]="{'has-error':(detailedBodyPart.touched && detailedBodyPart.invalid)}">
                <option value="" selected>Select</option>
                <option *ngFor="let bodyPart of bodyParts" [value]="bodyPart">{{bodyPart}}</option>
            </select>
            <div *ngIf="detailedBodyPart.touched && detailedBodyPart.invalid" class="alert alert-danger nw-field-error" id="detailedBodyPartErrorId">
                <span id="detailedBodyPartErrorMessage">Required</span>
            </div>
        </div>
    </div>
    <div *ngIf="!maxSeverity" id="hospitalized" class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <fieldset>
                <legend for="hospitalizedAnswers">Is the injured worker currently hospitalized?</legend>
                <div>
                    <div class="btn-group" data-toggle="buttons" id="hospitalizedAnswers">
                        <label class="btn btn-default form-check-label" [ngClass]="{'active':(hospitalizedAnswer.value ==='Yes')}">
                            <input name="hospitalizedAnswer" class="form-check-input" type="radio" checked="hospitalizedAnswer.value ==='Yes'" autocomplete="off" value="Yes"
                                [formControl]="hospitalizedAnswer">Yes
                        </label>
                        <label class="btn btn-default form-check-label" [ngClass]="{'active':(hospitalizedAnswer.value ==='No')}">
                            <input name="hospitalizedAnswer" class="form-check-input" type="radio" checked="hospitalizedAnswer.value ==='No'" autocomplete="off" value="No"
                                [formControl]="hospitalizedAnswer">No
                        </label>
                        <label class="btn btn-default form-check-label" [ngClass]="{'active':(hospitalizedAnswer.value ==='unknown')}">
                            <input name="hospitalizedAnswer" class="form-check-input" type="radio" checked="hospitalizedAnswer.value ==='unknown'" autocomplete="off" value="unknown"
                                [formControl]="hospitalizedAnswer">I don't know
                        </label>
                    </div>
                    <div *ngIf="hospitalizedAnswer.invalid && hospitalizedAnswer.touched" class="alert alert-danger nw-field-error" id="hospitalizedAnswerErrorId">
                        <span *ngIf="hospitalizedAnswer.hasError('required')" id="hospitalizedAnswerErrorMessage">Required</span>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
    <div *ngIf="loseTime" id="missedTime" class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <fieldset>
                <legend for="timeFromWorkAnswers">Did the injured worker miss any time from work?</legend>
                <div>
                    <div class="btn-group" data-toggle="buttons" id="timeFromWorkAnswers">
                        <label class="btn btn-default form-check-label" [ngClass]="{'active':(timeFromWorkAnswer.value ==='Yes')}">
                            <input name="timeFromWorkAnswer" class="form-check-input" type="radio" checked="timeFromWorkAnswer.value ==='Yes'" autocomplete="off" value="Yes"
                                [formControl]="timeFromWorkAnswer">Yes
                        </label>
                        <label class="btn btn-default form-check-label" [ngClass]="{'active':(timeFromWorkAnswer.value ==='No')}">
                            <input name="timeFromWorkAnswer" class="form-check-input" type="radio" checked="timeFromWorkAnswer.value ==='No'" autocomplete="off" value="No"
                                [formControl]="timeFromWorkAnswer">No
                        </label>
                        <label class="btn btn-default form-check-label" [ngClass]="{'active':(timeFromWorkAnswer.value ==='unknown')}">
                            <input name="timeFromWorkAnswer" class="form-check-input" type="radio" checked="timeFromWorkAnswer.value ==='unknown'" autocomplete="off" value="unknown"
                                [formControl]="timeFromWorkAnswer">I don't know
                        </label>
                    </div>
                    <div *ngIf="timeFromWorkAnswer.invalid && timeFromWorkAnswer.touched" class="alert alert-danger nw-field-error" id="timeFromWorkAnswerErrorId">
                        <span *ngIf="timeFromWorkAnswer.hasError('required')" id="timeFromWorkAnswerErrorMessage">Required</span>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
    <div *ngIf="missDays" id="lostDaysOfWork" class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <fieldset>
                <legend for="lostDaysOfWorkAnswers">Did the injured worker miss 4 or more days of work?</legend>
                <div>
                    <div class="btn-group" data-toggle="buttons" id="lostDaysOfWorkAnswers">
                        <label class="btn btn-default form-check-label" [ngClass]="{'active':(lostDaysOfWorkAnswer.value ==='Yes')}">
                            <input name="lostDaysOfWorkAnswer" class="form-check-input" type="radio" checked="lostDaysOfWorkAnswer.value ==='Yes'" autocomplete="off" value="Yes"
                                [formControl]="lostDaysOfWorkAnswer">Yes
                        </label>
                        <label class="btn btn-default form-check-label" [ngClass]="{'active':(lostDaysOfWorkAnswer.value ==='No')}">
                            <input name="lostDaysOfWorkAnswer" class="form-check-input" type="radio" checked="lostDaysOfWorkAnswer.value ==='No'" autocomplete="off" value="No"
                                [formControl]="lostDaysOfWorkAnswer">No
                        </label>
                        <label class="btn btn-default form-check-label" [ngClass]="{'active':(lostDaysOfWorkAnswer.value ==='unknown')}">
                            <input name="lostDaysOfWorkAnswer" class="form-check-input" type="radio" checked="lostDaysOfWorkAnswer.value ==='unknown'" autocomplete="off" value="unknown"
                                [formControl]="lostDaysOfWorkAnswer">I
                            don't know
                        </label>
                    </div>
                    <div *ngIf="lostDaysOfWorkAnswer.invalid && lostDaysOfWorkAnswer.touched" class="alert alert-danger nw-field-error" id="lostDaysOfWorkAnswerErrorId">
                        <span *ngIf="lostDaysOfWorkAnswer.hasError('required')" id="lostDaysOfWorkAnswerErrorMessage">Required</span>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
    <div *ngIf="returned" class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="returnedDate">Date injured worker returned (or will return) to work</label>
            <input type="text" class="form-control" id="returnedDate" name="returnedDate" [formControl]="returnedDate" aria-required="true" aria-describedby="returnedDate" placeholder="mm/dd/yyyy"
                [ngClass]="{'has-error':(returnedDate.invalid && returnedDate.touched)}">
            <div *ngIf="returnedDate.invalid && returnedDate.touched" class="alert alert-danger nw-field-error" id="returnedDateErrorId">
                <span *ngIf="returnedDate.hasError('required')" id="returnedDateErrorMessage">Required</span>
                <span *ngIf="returnedDate.hasError('pattern')" id="returnedDateErrorMessage">Returned Date is invalid</span>
            </div>
            <input type="checkbox" #returnedDateNotKnown id="returnedDate" style="margin-right:10px;margin-bottom:20px" (change)="dateFilterChanged(returnedDateNotKnown.checked,returnedDate)">I
            don't know
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="notifiedDate">Date employer notified</label>
            <input type="text" class="form-control" id="notifiedDate" name="notifiedDate" [formControl]="notifiedDate" aria-required="true" aria-describedby="notifiedDate" placeholder="mm/dd/yyyy"
                [ngClass]="{'has-error':(notifiedDate.invalid && notifiedDate.touched)}">
            <div *ngIf="notifiedDate.invalid && notifiedDate.touched" class="alert alert-danger nw-field-error" id="notifiedDateErrorId">
                <span *ngIf="notifiedDate.hasError('required')" id="notifiedDateErrorMessage">Required</span>
                <span *ngIf="notifiedDate.hasError('pattern')" id="notifiedDateErrorMessage">Date employer notified is invalid</span>
            </div>
            <input type="checkbox" #notifiedDateNotKnown id="notifiedDate" style="margin-right:10px;margin-bottom:20px" (change)="dateFilterChanged(notifiedDateNotKnown.checked,notifiedDate)">I
            don't know
        </div>
    </div>
</div>